export const getEmailTwoColumnSection = (leftColumn, rightColumn) => `
        <tr>
            <td
            style="
                font-size: 0px;
                padding: 20px 0;
                padding-top: 0;
                padding-right: 4px;
                padding-bottom: 0;
                padding-left: 4px;
                word-break: break-word;
            "
            >
            <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:598px;" width="598" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
            <div style="margin: 0px auto; max-width: 598px">
                <table
                align="center"
                border="0"
                cellpadding="0"
                cellspacing="0"
                role="presentation"
                style="width: 100%"
                >
                <tbody>
                    <tr>
                    <td
                        style="
                        direction: ltr;
                        font-size: 0px;
                        padding: 20px 0;
                        padding-bottom: 0;
                        padding-left: 4px;
                        padding-right: 4px;
                        padding-top: 0;
                        text-align: center;
                        "
                    >
                        <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:590px;" ><![endif]-->
                        <div
                        class="mj-column-per-100 mj-outlook-group-fix"
                        style="
                            font-size: 0px;
                            text-align: left;
                            direction: ltr;
                            display: inline-block;
                            vertical-align: top;
                            width: 100%;
                        "
                        >
                        <table
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                            style="vertical-align: top"
                            width="100%"
                        >
                            <tbody>
                            <tr>
                                <td
                                style="
                                    font-size: 0px;
                                    word-break: break-word;
                                "
                                >
                                <div
                                    class="mj-column-per-100 mj-outlook-group-fix"
                                    style="
                                    font-size: 0;
                                    line-height: 0;
                                    text-align: left;
                                    display: inline-block;
                                    width: 100%;
                                    direction: ltr;
                                    "
                                >
                                    <!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td style="vertical-align:top;width:289px;" ><![endif]-->
                                    <div
                                    class="mj-column-per-49 mj-outlook-group-fix"
                                    style="
                                        font-size: 0px;
                                        text-align: left;
                                        direction: ltr;
                                        display: inline-block;
                                        vertical-align: top;
                                        width: 49%;
                                    "
                                    >
                                    <table
                                        border="0"
                                        cellpadding="0"
                                        cellspacing="0"
                                        role="presentation"
                                        style="
                                        background-color: #ffffff;
                                        border-radius: 4px;
                                        vertical-align: top;
                                        "
                                        width="100%"
                                    >
                                        <tbody>
                                        <tr>
                                            <td
                                            align="left"
                                            style="
                                                font-size: 0px;
                                                padding: 10px 25px;
                                                padding-right: 8px;
                                                padding-left: 8px;
                                                word-break: break-word;
                                            "
                                            >
                                            <div
                                                style="
                                                font-family: Roboto, Arial;
                                                font-size: 12px;
                                                font-weight: 600;
                                                line-height: 1;
                                                text-align: left;
                                                color: #000000;
                                                "
                                                data-testid=${leftColumn.dataTestId}
                                            >
                                                ${leftColumn.content}
                                            </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    <!--[if mso | IE]></td><td style="vertical-align:top;width:11px;" ><![endif]-->
                                    <div
                                    class="mj-column-per-2 mj-outlook-group-fix"
                                    style="
                                        font-size: 0px;
                                        text-align: left;
                                        direction: ltr;
                                        display: inline-block;
                                        vertical-align: top;
                                        width: 2%;
                                    "
                                    >
                                    <table
                                        border="0"
                                        cellpadding="0"
                                        cellspacing="0"
                                        role="presentation"
                                        style="
                                        vertical-align: top;
                                        "
                                        width="100%"
                                    >
                                        <tbody></tbody>
                                    </table>
                                    </div>
                                    <!--[if mso | IE]></td><td style="vertical-align:top;width:289px;" ><![endif]-->
                                    <div
                                    class="mj-column-per-49 mj-outlook-group-fix"
                                    style="
                                        font-size: 0px;
                                        text-align: left;
                                        direction: ltr;
                                        display: inline-block;
                                        vertical-align: top;
                                        width: 49%;
                                    "
                                    >
                                    <table
                                        border="0"
                                        cellpadding="0"
                                        cellspacing="0"
                                        role="presentation"
                                        style="
                                        background-color: #ffffff;
                                        border-radius: 4px;
                                        vertical-align: top;
                                        "
                                        width="100%"
                                    >
                                        <tbody>
                                        <tr>
                                            <td
                                            align="left"
                                            style="
                                                font-size: 0px;
                                                padding: 10px 25px;
                                                padding-right: 8px;
                                                padding-left: 8px;
                                                word-break: break-word;
                                            "
                                            >
                                            <div
                                                style="
                                                font-family: Roboto, Arial;
                                                font-size: 12px;
                                                font-weight: 600;
                                                line-height: 1;
                                                text-align: left;
                                                color: #000000;
                                                "
                                                data-testid=${rightColumn.dataTestId}
                                            >
                                                ${rightColumn.content}
                                            </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    <!--[if mso | IE]></td></tr></table><![endif]-->
                                </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                        <!--[if mso | IE]></td></tr></table><![endif]-->
                    </td>
                    </tr>
                </tbody>
                </table>
            </div>
            <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
        </tr>
`;
